import React from 'react';
import "./tutti-articoli.css";
import { useNavigate } from 'react-router-dom';

const TuttiArticoli = ({articles}) => {

    const navigate = useNavigate();

    return (
        <div className="all-articles">
          <h2 className="small-title">I miei articoli</h2>
          <div className="last-articles-container">
            {articles.map((article)=>(
              <div key={article.id} className="article-card">
                <h4>{article.date} - {article.author}</h4>
                <h3 onClick={() => navigate(`/articoli/${article.id}`)}>{article.title}</h3>
              </div>
            ))}
          </div>
        </div>
    )
}

export default TuttiArticoli;